import { render, staticRenderFns } from "./SetBalance.vue?vue&type=template&id=24f1e0ba&scoped=true"
import script from "./SetBalance.vue?vue&type=script&lang=js"
export * from "./SetBalance.vue?vue&type=script&lang=js"
import style0 from "./SetBalance.vue?vue&type=style&index=0&id=24f1e0ba&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f1e0ba",
  null
  
)

export default component.exports